export const BEMOVED_SUPPORT_PAGE_URL = 'https://www.bemoved.app/support';
export const CIMET_TOC_URL = 'https://utilities.bemoved.app/terms-condition';
export const CIMET_PRIVACY_POLICY_URL = 'https://utilities.bemoved.app/privacy-policy';
export const DELETE_ACCOUNT_REQUEST_URL = 'https://share.hsforms.com/1fRyMF47KTYaZs_BGx75rNAc9z7t';
